// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ItemTemplateItemDetailQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ItemTemplateItemDetailQuery = { __typename?: 'Query', items: Array<{ __typename?: 'Item', id: string, isSelection: boolean, name: string, costCode: { __typename?: 'CostCode', id: string, name: string }, tradeCategory?: { __typename?: 'TradeCategory', id: string, name: string } | null | undefined }>, locations: Array<{ __typename?: 'Location', id: string, name: string }>, unitsOfMeasure: Array<{ __typename?: 'UnitOfMeasure', id: string, name: string, useQuantity: boolean }> };

export type ItemTemplateItemProductsQueryVariables = Types.Exact<{
  itemId: Types.Scalars['ID']['input'];
}>;


export type ItemTemplateItemProductsQuery = { __typename?: 'Query', products: Array<{ __typename?: 'Product', id: string, name: string, items: Array<{ __typename?: 'Item', id: string }> }> };

export type ItemTemplateProductFragment = { __typename?: 'Product', id: string, name: string, items: Array<{ __typename?: 'Item', id: string }> };

export type ItemTemplateItemDetailItemFragment = { __typename?: 'Item', id: string, isSelection: boolean, name: string, costCode: { __typename?: 'CostCode', id: string, name: string }, tradeCategory?: { __typename?: 'TradeCategory', id: string, name: string } | null | undefined };

export const ItemTemplateProductFragmentDoc = gql`
    fragment ItemTemplateProduct on Product {
  id
  name
  items {
    id
  }
}
    `;
export const ItemTemplateItemDetailItemFragmentDoc = gql`
    fragment ItemTemplateItemDetailItem on Item {
  id
  name: displayName
  isSelection
  costCode {
    id
    name
  }
  tradeCategory {
    id
    name
  }
}
    `;
export const ItemTemplateItemDetailDocument = gql`
    query ItemTemplateItemDetail {
  items(filter: {status: [ACTIVE]}) {
    ...ItemTemplateItemDetailItem
  }
  locations {
    id
    name
  }
  unitsOfMeasure {
    id
    name
    useQuantity
  }
}
    ${ItemTemplateItemDetailItemFragmentDoc}`;

/**
 * __useItemTemplateItemDetailQuery__
 *
 * To run a query within a React component, call `useItemTemplateItemDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemTemplateItemDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemTemplateItemDetailQuery({
 *   variables: {
 *   },
 * });
 */
export function useItemTemplateItemDetailQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ItemTemplateItemDetailQuery, ItemTemplateItemDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ItemTemplateItemDetailQuery, ItemTemplateItemDetailQueryVariables>(ItemTemplateItemDetailDocument, options);
      }
export function useItemTemplateItemDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ItemTemplateItemDetailQuery, ItemTemplateItemDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ItemTemplateItemDetailQuery, ItemTemplateItemDetailQueryVariables>(ItemTemplateItemDetailDocument, options);
        }
// @ts-ignore
export function useItemTemplateItemDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ItemTemplateItemDetailQuery, ItemTemplateItemDetailQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ItemTemplateItemDetailQuery, ItemTemplateItemDetailQueryVariables>;
export function useItemTemplateItemDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ItemTemplateItemDetailQuery, ItemTemplateItemDetailQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ItemTemplateItemDetailQuery | undefined, ItemTemplateItemDetailQueryVariables>;
export function useItemTemplateItemDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ItemTemplateItemDetailQuery, ItemTemplateItemDetailQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ItemTemplateItemDetailQuery, ItemTemplateItemDetailQueryVariables>(ItemTemplateItemDetailDocument, options);
        }
export type ItemTemplateItemDetailQueryHookResult = ReturnType<typeof useItemTemplateItemDetailQuery>;
export type ItemTemplateItemDetailLazyQueryHookResult = ReturnType<typeof useItemTemplateItemDetailLazyQuery>;
export type ItemTemplateItemDetailSuspenseQueryHookResult = ReturnType<typeof useItemTemplateItemDetailSuspenseQuery>;
export type ItemTemplateItemDetailQueryResult = Apollo.QueryResult<ItemTemplateItemDetailQuery, ItemTemplateItemDetailQueryVariables>;
export const ItemTemplateItemProductsDocument = gql`
    query ItemTemplateItemProducts($itemId: ID!) {
  products(filter: {item: [$itemId], custom: false}, first: 1000) {
    ...ItemTemplateProduct
  }
}
    ${ItemTemplateProductFragmentDoc}`;

/**
 * __useItemTemplateItemProductsQuery__
 *
 * To run a query within a React component, call `useItemTemplateItemProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemTemplateItemProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemTemplateItemProductsQuery({
 *   variables: {
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useItemTemplateItemProductsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ItemTemplateItemProductsQuery, ItemTemplateItemProductsQueryVariables> & ({ variables: ItemTemplateItemProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ItemTemplateItemProductsQuery, ItemTemplateItemProductsQueryVariables>(ItemTemplateItemProductsDocument, options);
      }
export function useItemTemplateItemProductsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ItemTemplateItemProductsQuery, ItemTemplateItemProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ItemTemplateItemProductsQuery, ItemTemplateItemProductsQueryVariables>(ItemTemplateItemProductsDocument, options);
        }
// @ts-ignore
export function useItemTemplateItemProductsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ItemTemplateItemProductsQuery, ItemTemplateItemProductsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ItemTemplateItemProductsQuery, ItemTemplateItemProductsQueryVariables>;
export function useItemTemplateItemProductsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ItemTemplateItemProductsQuery, ItemTemplateItemProductsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ItemTemplateItemProductsQuery | undefined, ItemTemplateItemProductsQueryVariables>;
export function useItemTemplateItemProductsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ItemTemplateItemProductsQuery, ItemTemplateItemProductsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ItemTemplateItemProductsQuery, ItemTemplateItemProductsQueryVariables>(ItemTemplateItemProductsDocument, options);
        }
export type ItemTemplateItemProductsQueryHookResult = ReturnType<typeof useItemTemplateItemProductsQuery>;
export type ItemTemplateItemProductsLazyQueryHookResult = ReturnType<typeof useItemTemplateItemProductsLazyQuery>;
export type ItemTemplateItemProductsSuspenseQueryHookResult = ReturnType<typeof useItemTemplateItemProductsSuspenseQuery>;
export type ItemTemplateItemProductsQueryResult = Apollo.QueryResult<ItemTemplateItemProductsQuery, ItemTemplateItemProductsQueryVariables>;